<template>
  <DashboardPanel
    class="cheque-panel"
    title="Cheque Register"
    subtitle="Pending clearance, incoming and issued cheques."
    icon="file-text"
    icon-tone="warn"
  >
    <template #actions>
      <button class="link-btn" @click="$router.push('/bank-cheques')">Open Cheques</button>
    </template>
    <div class="cheque-list" v-if="visibleCheques.length">
      <div v-for="cheque in visibleCheques" :key="cheque.chequeid" class="cheque-row">
        <div>
          <strong>{{ cheque.party_name }}</strong>
          <span>#{{ cheque.cheque_number }} &middot; {{ formatDate(cheque.expected_clearance_date) }}</span>
        </div>
        <div class="text-end">
          <strong>{{ formatCurrency(cheque.amount) }}</strong>
          <span class="status-pill" :class="chequeStatusClass(cheque.status)">{{ prettyStatus(cheque.status) }}</span>
        </div>
      </div>
    </div>
    <div class="empty-state compact" v-else>No cheque entries to show.</div>
  </DashboardPanel>
</template>

<script>
import DashboardPanel from "./DashboardPanel.vue";
import { chequeStatusClass } from "../dashboardCards";
import { formatCurrency, formatDate, prettyStatus } from "@/utils/formatters";

const MAX_CHEQUES = 4;

export default {
  name: "ChequeRegister",
  components: { DashboardPanel },
  props: {
    cheques: { type: Array, required: true },
  },
  computed: {
    visibleCheques() {
      return this.cheques.slice(0, MAX_CHEQUES);
    },
  },
  methods: { chequeStatusClass, formatCurrency, formatDate, prettyStatus },
};
</script>
